<template>
  <div style="margin-top: 80px">
    <div class="container-fluid">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/4 xl:w-1/4 sm:w-1/2">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="BoxIcon"
            icon-right
            :statistic="countOfProducts"
            :statisticTitle="$t('productNumber')"
            color="success"
          />
        </div>
        <div
          v-if="$store.state.role != 'Customer' && $store.state.role != 'Admin'"
          class="vx-col w-full lg:w-1/4 xl:w-1/4 sm:w-1/2"
        >
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="UsersIcon"
            icon-right
            :statistic="countOfCategories"
            :statisticTitle="$t('countOfCategories')"
            color="primary"
          />
        </div>
        <div
          v-if="$store.state.role == 'Admin'"
          class="vx-col w-full lg:w-1/4 xl:w-1/4 sm:w-1/2"
        >
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="CameraIcon"
            icon-right
            :statistic="countOfMachines"
            :statisticTitle="$t('numberMachine')"
            color="warning"
          />
        </div>
        <div
          v-if="$store.state.role != 'Customer'"
          class="vx-col w-full lg:w-1/4 xl:w-1/4 sm:w-1/2"
        >
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="UsersIcon"
            icon-right
            :statistic="countOfCustomers"
            :statisticTitle="$t('customerNumber')"
            color="primary"
          />
        </div>
        <div
          v-if="$store.state.role != 'Customer'"
          class="vx-col w-full lg:w-1/4 xl:w-1/4 sm:w-1/2"
        >
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="ArchiveIcon"
            icon-right
            :statistic="usedQuota"
            :statisticTitle="$t('usedQuota')"
            color="dark"
          />
        </div>
        <div class="vx-col w-full lg:w-1/4 xl:w-1/4 sm:w-1/2">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="AlertOctagonIcon"
            icon-right
            :statistic="remainQuota"
            :statisticTitle="$t('remainQuota')"
            color="danger"
          />
        </div>
      </div>
    </div>
    <!--<div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <iframe
            class="vh-100 w-full"
            src="https://panel.360photoboxcloud.com/viewer360/viewer.html?id=66"
            width="auto"
            height="auto"
            frameborder="0"
            scrolling="no"
            style="background-color: #fff; border: 0;"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
/* eslint-disable */
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import http from "../http/http-helper";

export default {
  components: {
    StatisticsCardLine,
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title;
      },
    },
  },
  data() {
    return {
      countOfProducts: "",
      countOfMachines: "",
      countOfCustomers: "",
      usedQuota: "",
      remainQuota: "",
      countOfCategories: "",
    };
  },
  methods: {
    getInfo() {
      let path = "/Users/getpanelinfo";
      http.get(path).then((response) => {
        if (this.$store.state.role == "Admin") {
          this.countOfMachines = response.countOfMachines;
          this.countOfProducts = response.countOfProducts;
          this.countOfCustomers = response.countOfCustomers;
          this.usedQuota = parseInt(response.usedQuota / 1024) + " GB";
          this.remainQuota = parseInt(response.remainQuota / 1024) + " GB";
        }

        if (this.$store.state.role == "User") {
          this.countOfCategories = response.countOfCategories;
          this.countOfProducts = response.countOfProducts;
          this.countOfCustomers = response.countOfCustomers;
          this.usedQuota = parseInt(response.usedQuota / 1024) + " GB";
          this.remainQuota = parseInt(response.remainQuota / 1024) + " GB";
        }
        if (this.$store.state.role == "Customer") {
          this.countOfProducts = response.countOfProducts;
          this.remainQuota = parseInt(response.remainQuota / 1024) + " GB";
        }
      });
    },
  },
  created() {
    this.getInfo();
  },
};
</script>